export default {
    error: null,
    quotationId: null,
    quotation: null,
    newSelects: [],
    lastQuotationSaved: null,
    hasQuotation: false,
    faye: {
        channel: null,
        url: null,
        client: null,
        result: null,
    },
    automationBearer: null
}



// WEBPACK FOOTER //
// ./src/shared/helpers/vuex/state.js